<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/" i18n>Home</a></li>
                <li i18n>News Papaer/Magazin Details</li>
                <li></li>
            </ul>
            <h2 i18n>News Papaer/Magazin Details</h2>
        </div>
    </div>
</div>

<div class="blog-details-area ptb-100" [class.dark-blog-details-area]="themeService.isDark()">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="blog-details-desc">
                    <div class="article-content">

                        <div class="entry-meta">
                            <ul>
                                <li>
                                    <i class='bx bx-calendar'></i>
                                    <span i18n>CREATED DATE</span>
                                    <a>{{newsPaper?.created_at|date:'longDate'}}</a>
                                </li>
                            </ul>
                        </div>
                        <h3>{{newsPaper?.title}}</h3>

                        <p> {{newsPaper?.text}}</p>
                        
                        <ul class="wp-block-gallery columns-3">
                            <li class="blocks-gallery-item" *ngFor="let img of newsPaper?.images">
                                <figure>
                                    <img [src]="imageURL+img.url" style="max-height:25em" alt="image">
                                </figure>
                            </li>
                           

                        </ul>


                    </div>

                </div>

            </div>
        </div>
    </div>